import { Icon, Text, HStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

export interface ReportModalHeaderProps {
  directionIsBottom: boolean;
  direction: 'bottom' | 'right';
  onClose: () => void;
}

export const ReportModalHeader: React.FC<ReportModalHeaderProps> = ({
  direction,
  directionIsBottom,
  onClose,
}) => {
  return (
    <>
      {directionIsBottom && (
        <Box
          w="55px"
          alignSelf="center"
          background={'neutral.lightest'}
          borderRadius={BoxRadius.sm}
          h={1}
        />
      )}

      <HStack alignItems="center" justifyContent="space-between">
        <Text variant="semibold" fontSize="lg" lineHeight="distant" color="neutral.black">
          Escolha os filtros de pesquisa:
        </Text>

        <Pressable onPress={onClose}>
          <Icon
            name="Close"
            size="xs"
            variant="rounded"
            {...(direction !== 'bottom' && { borderWidth: 0.05 })}
            backgroundColor="transparent"
            color="brand.primary.principal"
            borderColor="brand.primary.principal"
          />
        </Pressable>
      </HStack>
    </>
  );
};
